import type { IconSvgObject } from './types';

const ArcherIcon: IconSvgObject = [
  ["path", { d: "M12 17.0016L21 20.9977C20.4444 20.4422 19.4898 18.6417 20.1158 15.883C20.8982 12.4347 22.4299 8.90472 17 7.00163C15.0965 1.57298 11.5649 3.10336 8.11578 3.88565C5.35649 4.51148 3.55556 3.55706 3 3.00163L7 12.0016", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6 17.999H3L6 14.9997H9V17.999L6 20.9984V17.999Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M9 15.0016L21 3.00163M21 3.00163H18M21 3.00163V6.00163", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default ArcherIcon;
